import { useContext, useEffect, useTransition, useOptimistic, useState, useRef } from "react";
import { format, addMilliseconds } from "date-fns";

import { TextField, CircularProgress } from "@mui/material";
import axios from "axios";
import { motion, spring } from 'framer-motion';

// Dialog関連
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, } from '@mui/material';
import { TableContainer, Paper, Table, TableHead, TableRow, TableBody, TableCell } from '@mui/material';

import AppContext from "../contexts/AppContext";
import CookieContext from "../contexts/CookieContext";

// const optimisticAction = (_currentState, optimisticColor) => {
//   // ここで楽観的な処理をする
//   return optimisticColor;
// };


const OptimisticUpdate = () => {
  const { apiHost, AppButton } = useContext(AppContext);
  const basePath = 'checklist/';
  const { cookies, refreshJwtCookies } = useContext(CookieContext);

  const [error, setError] = useState();
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState('abc');
  const [sendingMessage, setSendingMessage] = useState('');
  const inputRef = useRef(null);

  const [messageBoxOpen, setMessageBoxOpen] = useState(false);
  const [messageBoxId, setMessageBoxId] = useState('');
  const [messageBoxTitle, setMessageBoxTitle] = useState('');
  const [messageBoxMessage, setMessageBoxMessage] = useState('');

  const [page, setPage] = useState(1);
  const [updateStatus, setUpdateStatus] = useState('');

  const [targetItems, setTargetItems] = useState({});
  // const [paginator, setPaginator] = useState({count: 0, next: '', previous: '', current: 1, final: '', size: 0 })

  const handleMessageBoxOpen = (id, title, message) => {
    setMessageBoxTitle(title);
    setMessageBoxMessage(message);
    setMessageBoxOpen(true);
  }
  const handleMessageBoxClose = () => {
    setMessageBoxOpen(false);
  }

  // const [loadingOpen, setLoadingOpen] = useState(false);

  const [isPending, startTransition] = useTransition();
  const [color, setColor] = useState("blue");
  const [displayLikeColor, addOptimistic] = useOptimistic(color,
    (_currentState, optimisticColor) => {
      // ここで楽観的な処理をする
      return optimisticColor;
    });


  // https://zenn.dev/uhyo/books/react-19-new/viewer/use-optimistic
  // https://qiita.com/Yasushi-Mo/items/161a61f4c37578769847
  // https://ja.react.dev/reference/react/useOptimistic#optimistically-updating-with-forms
  const [optimisticMessage, addOptimisticMessage] = useOptimistic(
    messages,
    (state, newMessage) => [
      {
        text: newMessage,
        sending : true
      },
      ...state,
    ]
  );
  
  const [updateButtonDisabled, setUpdateButtonDisabled] = useState('');

    // load時
    useEffect(() => {
      // fetchpagers('?page=' + page);
      fetchitems('?page=' + page);
      // 更新ボタンを押せないようにする
      // message ? setUpdateButtonDisabled('') : setUpdateButtonDisabled('disabled');
    }, []);
  
  // page変更時
  useEffect(() => {
    // fetchpagers('?page=' + page);
    // fetchitems('?page=' + page);
    // alert(message)
    // 更新ボタンを押せないようにする
    message ? setUpdateButtonDisabled('') : setUpdateButtonDisabled('disabled');
  }, [message, updateButtonDisabled, updateStatus, targetItems]);

  // const resetTextbox = async () => {
  //   setSendingMessage('');
  //   setUpdateButtonDisabled('');
  //   setUpdateStatus('');
  //   document.getElementById('textbox')?.focus();
  // }

  const updateCompleted = async () => {
    setSendingMessage('メッセージ');
    setUpdateStatus('完了');
  }

  const postMessage = async () => {
    await setSendingMessage(message);

    // 更新ボタンを押せないようにする
    setUpdateButtonDisabled('disabled');
    setUpdateStatus('【更新中】');
    setMessage('');
    document.getElementById('textbox')?.focus();
    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        };

        if (message) {
          startTransition(async () => {
            // const response = await axios.put(`${apiHost}${basePath}2/`, 
            const response = await axios.post(`${apiHost}${basePath}`, 
                {
                name: message,
              },
              {headers},
            )

            if (response.status === 201) {
              // textboxをクリアし、フォーカスを当てる
              // resetTextbox();
              updateCompleted();

              // データを新規追加したので、現在ページを最新ページへ設定
              setPage(1);

              // 元々最新ページにいる場合はuseEffectが作用しないので、fetchitems=データ更新を実行
              // （最新ページにいない場合は上記のsetPage(1)でuseEffectが作用）
              fetchitems('?page=1');
              // setColor(response.data.id);
              setColor('red');
            } else if (response.status === 401) {
              setError('ログインしてください');
            } else {
              setError('エラー');
            }
          });
        }
        else {
          handleMessageBoxOpen('xxx', 'エラー', 'メッセージを入れてください');
          // textboxをクリアし、フォーカスを当てる
          // await resetTextbox();

          // メッセージボックスの「OK」ボタンにフォーカスを当てる
          document.getElementById('messagebox')?.focus();
        }
      } else {
        setError('認証エラー');
      }
    } catch (err) {
      console.log(err);
    } finally {
      // setUpdateButtonDisabled('');
      // inputRef.current.value = '';
    }
  }

  const fetchitems = async (param) => {

    try {
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${cookies.jwtAccess}`,
      };

      const response = await fetch(apiHost + basePath + 'check/1/' + param, {headers});

      if (response.status === 200) {
        const data = await response.json();
        setTargetItems(data);
        // fetchpagers('?page=' + page);
      }
      else if (response.status === 401) {
        setError('ログインしてください');
      }
      else {
        setError('エラー');
      }
    } catch (err) {
      console.log(err);
    }
  }

  const targetItemsList = () => {
    return (
      <>
        {Array.isArray(targetItems)
          ? targetItems.map((targetItem, index) => {
            if(index < targetItems.length) {
              return (
                <>
                    <ul style={{ textAlign: 'left' }}>{targetItem.id}{targetItem.username}{targetItem.created_at}{targetItem.message}</ul>
                </>
              )
            }
          })
          : null
        }

        <div style={{ margin: "5px" }}>
          {/* データ一覧 */}
          {/* <TableContainer component={Paper} sx={{ width:'100%' }}>
            <Table stickyHeader sx={{ width:'100%' }}>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width:'10%' }}>index</TableCell>
                  <TableCell sx={{ width:'10%' }}>id</TableCell>
                  <TableCell sx={{ width:'20%' }}>ユーザ名</TableCell>
                  <TableCell sx={{ width:'10%' }}>created_at</TableCell>
                  <TableCell sx={{ width:'40%' }}>message</TableCell>
                  <TableCell sx={{ width:'10%' }}>ip_addr</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.isArray(targetItems)
                  ? targetItems.map((targetItem, index) => {
                    if(index < targetItems.length) {
                      return (
                        <>
                          <TableRow>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>【{targetItem.id}】</TableCell>
                            <TableCell>【{targetItem.username}】</TableCell>
                            <TableCell>{format(targetItem.created_at, "yyyy-MM-dd HH:mm:ss")}</TableCell>
                            <TableCell>{targetItem.message}</TableCell>
                            <TableCell>{targetItem.ip_addr}</TableCell>
                          </TableRow>
                        </>
                      )
                    }
                  })
                  : null
                }
              </TableBody>
            </Table>
          </TableContainer> */}
        </div>

      </>
    )
  }

  return (
    <>
      <h3>color:{color}</h3>
      <h3>displayLikeColor:{displayLikeColor}</h3>
      <div className="container">
      <TextField ref={inputRef} fullWidth id="textbox" value={message} onChange={(e) => setMessage(e.target.value)} />
      </div>
      <div className="container">
        <AppButton onClick={() => {postMessage(message)}} disabled={updateButtonDisabled}>送信</AppButton>

        {/* <motion.div
          initial={{ x: 300, opacity: 0, }}
          animate={{ x: 10, opacity: 1, }}
          transition={{ type:spring, delay: 3, duration: 1, repeat: Infinity }}
        >
          {updateStatus}
          {sendingMessage}
        </motion.div> */}

        <motion.div
          initial={{ opacity: 0, color:'#6960ec' }}
          animate={{ opacity: 1, color:'#1dad0a' }}
          transition={{ delay: 3, duration: 1, repeat: Infinity }}
        >
          {updateStatus}
        </motion.div>
        <motion.div
          initial={{ x: 100, opacity: 0, }}
          animate={{ x: 10, opacity: 1, }}
          transition={{ type:spring, delay: 3, duration: 1, repeat: Infinity }}
        >
          {sendingMessage}
        </motion.div>
      </div>

      {/* <div style={{display: 'flex', flexWrap: 'wrap', padding: '10px', margin: '0 auto', width: 100,
        background: 'linear-gradient(180deg, #000000, #000000)', border: '1px solid #cccccc', color: '#cccccc',
        fontFamily: '"Noto Sans Math", sans-serif', fontWeight: 500, textAlign: 'left' }}> */}
      <div style={{background: 'linear-gradient(180deg, #000000, #000000)', border: '1px solid #cccccc', color: '#cccccc',}}>
        { isPending ? (
          <>
            <div>
              Loading...
            </div>
            {targetItemsList()}
          </>
        ) : (
          <>
            {targetItemsList()}
            {/* {Array.isArray(targetItems) ? targetItems.map((targetItem, index) => {
              if(index < targetItems.length) {
                return (<div key={index + 1} style={{ width: 600 + 'px', background: 'linear-gradient(180deg, #9fc1ff, #dd97fd)', color: '#000000', }}>{index + 1}【{targetItem.created_at}】{targetItem.message}</div>);
              }
            })
              : null
            } */}
          </>
        )}
      </div>

      <div>
        color:{color}
        <div>color:{color}</div>
        <div style={{ color: displayLikeColor }}>displayLikeColor:{displayLikeColor}</div>
        <div>sendingMessage:{sendingMessage}</div>
        <div>message:{message}</div>
        <div>updateStatus:{updateStatus}</div>
      </div>
      <div>messages.sending:{messages}</div>

      <Dialog
        open={messageBoxOpen}
        onClose={handleMessageBoxClose}
        aria-labelledby="messageBox-dialog-title"
        aria-describedby="messageBox-dialog-description"
      >
        <DialogTitle sx={{m:0, p:2}} id="messageBox-dialog-title">
          【{messageBoxTitle}】
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description">
            {messageBoxMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <AppButton id='messagebox' onClick={handleMessageBoxClose} autoFocus>OK</AppButton>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default OptimisticUpdate